import { useNavigate } from 'react-router-dom';
import { Select } from 'antd';
import { useBibleTranslations, useLanguage, useGetBibleUrlParams } from 'core/hooks';
import { IBibleTranslation } from 'types';
import { useMemoSelector } from 'store/hooks';
import { getAuthState } from 'store/selectors/auth';

export const NOTES_VALUE = 'notes';

function TranslationsSelector() {
  const navigate = useNavigate();
  const { book, chapter, verse, translations } = useGetBibleUrlParams();
  const { bibleTranslations } = useBibleTranslations();
  const { currentLanguage } = useLanguage();
  const { userInfo } = useMemoSelector(getAuthState);

  const parts = translations ? translations.split(',') : [];
  const selectedIds = parts.filter(p => p !== NOTES_VALUE).map(Number).filter(n => !Number.isNaN(n));
  const notesSelected = parts.includes(NOTES_VALUE);

  const options = [
    ...bibleTranslations.map((translation: IBibleTranslation) => ({
      label: `${translation.name} ${translation.translator_name}`,
      value: translation.id,
    })),
    ...(userInfo?._id
      ? [{ label: currentLanguage.notes, value: NOTES_VALUE as string }]
      : []),
  ];

  const selectValue = [...selectedIds, ...(notesSelected ? [NOTES_VALUE] : [])];

  const handleChange = (value: (string | number)[]) => {
    if (!book || !chapter) return;
    const notesIncluded = value.includes(NOTES_VALUE);
    const ids = value.filter(v => v !== NOTES_VALUE) as number[];
    if (ids.length === 0 && notesIncluded) ids.push(1);
    if (ids.length === 0) return;
    const translationParam = notesIncluded ? `${ids.join(',')},${NOTES_VALUE}` : ids.join(',');
    const verseParam = verse ?? '0';
    navigate(`/bible/${book}/${chapter}/${verseParam}/${translationParam}`);
  };

  if (!book || !chapter || !translations) return null;

  return (
    <div className="bible-v2-header__translations-select">
      <Select
        mode="multiple"
        placeholder={currentLanguage.bibleTranslations}
        value={selectValue}
        onChange={handleChange}
        options={options}
        allowClear={false}
        maxTagCount={1}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
}

export default TranslationsSelector;
